import React, { useEffect, useState, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  OverlayTrigger,
  Row,
  Toast,
  Tooltip
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import {FaSearch} from 'react-icons/fa'
import { formato_monto } from '../../common/Formatos'



const SolicitudDescuento = ({handleClose}) => {
  
   const data_solicitud = useSelector((state) => state.SolicitudDescuentoReducer)
   const { cfg_form26, datosSolicitud} = data_solicitud
   const data_recepciona = useSelector((state) => state.casoGeneralReducer)
   const { llaves} = data_recepciona
   
  return (
    <>
 <style type='text/css'>
      
    </style>
      
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}
          >
            {cfg_form26
              ? cfg_form26.cfg_form26['consultasoldescuento-title-solicitud']
              : ''} 
          </Card.Header>
          <Container>
           
            
              {cfg_form26? (
                <div >
                  
                  <Row >
                 
                    <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-ambito'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['ambitoGestion'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['ambitoGestion'] !== null &&
                        datosSolicitud.datosSolicitud[0]['ambitoGestion'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['ambitoGestion']
                        : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                       className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-usuario'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['usuarioSolDcto'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['usuarioSolDcto'] !== null &&
                        datosSolicitud.datosSolicitud[0]['usuarioSolDcto'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['usuarioSolDcto']
                        : ''}
                </Form.Text>
                   </Col>
                    
                   <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-fechasol'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['fecSolDctoFormat'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['fecSolDctoFormat'] !== null &&
                        datosSolicitud.datosSolicitud[0]['fecSolDctoFormat'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['fecSolDctoFormat']
                        : ''}
                </Form.Text>
                     
                    </Col>  
                                  
                     
                
               </Row>
               <Row>
                 <Col>
                 <div >
                 <Form.Label
                       className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '17px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-subtitle1-solicitud'
                          ]
                        }
                      </Form.Label>{' '}
 
               <hr style={{ color: '#04005D', height: '2px', marginTop:'-15px', marginLeft:'15%'}}></hr>
                   </div>
           
                 </Col>
               </Row>
               <Container>
               <Row >
                 
                 <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form26.cfg_form26[
                         'consultasoldescuento-lbl-moneda'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                     datosSolicitud.datosSolicitud[0]['monedaRecobro'] !== undefined &&
                     datosSolicitud.datosSolicitud[0]['monedaRecobro'] !== null &&
                     datosSolicitud.datosSolicitud[0]['monedaRecobro'] !== ''
                     ? datosSolicitud.datosSolicitud[0]['monedaRecobro']
                     : ''}
             </Form.Text>
                 </Col>
                 <Col md='3'>
                   <Form.Label
                    className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form26.cfg_form26[
                         'consultasoldescuento-lbl-mtoneto'
                       ]
                     }
                   </Form.Label>
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                     datosSolicitud.datosSolicitud[0]['montoNeto'] !== undefined &&
                     datosSolicitud.datosSolicitud[0]['montoNeto'] !== null &&
                     datosSolicitud.datosSolicitud[0]['montoNeto'] !== ''
                     ? formato_monto(datosSolicitud.datosSolicitud[0]['montoNeto'])
                     : ''}
             </Form.Text>
                </Col>
                 
                <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form26.cfg_form26[
                         'consultasoldescuento-lbl-porcrec'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3 mx-4' style={{ fontSize: '14px' }}>
                   {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                     datosSolicitud.datosSolicitud[0]['porcRecobro'] !== undefined &&
                     datosSolicitud.datosSolicitud[0]['porcRecobro'] !== null &&
                     datosSolicitud.datosSolicitud[0]['porcRecobro'] !== ''
                     ? datosSolicitud.datosSolicitud[0]['porcRecobro']
                     : ''}
             </Form.Text>
                  
                 </Col>  
                <Col md='3'>
                   <Form.Label
                    className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form26.cfg_form26[
                         'consultasoldescuento-lbl-mtorecobro'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== undefined &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== null &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== ''
                     ? formato_monto(datosSolicitud.datosSolicitud[0]['montoRecobro'])
                     : ''}
             </Form.Text>
                  
                 </Col>  
                               
                  
             
            </Row>
            </Container> 
            <Row>
              <Col>
              <div >
              <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '17px' }}
                   >
                     {
                       cfg_form26.cfg_form26[
                         'consultasoldescuento-subtitle2-solicitud'
                       ]
                     }
                   </Form.Label>{' '}

            <hr style={{ color: '#04005D', height: '2px', marginTop:'-15px', marginLeft:'15%'}}></hr>
                </div>
        
              </Col>
            </Row>
            <Container>
            <Row>
            <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-monedasoldcto'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['monedaSolDcto'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['monedaSolDcto'] !== null &&
                        datosSolicitud.datosSolicitud[0]['monedaSolDcto'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['monedaSolDcto']
                        : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                       className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-propuestarec'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['montoPropuestoSolDcto'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['montoPropuestoSolDcto'] !== null &&
                        datosSolicitud.datosSolicitud[0]['montoPropuestoSolDcto'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['montoPropuestoSolDcto']
                        : ''}
                </Form.Text>
                   </Col>
                    
                   <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-porcpropto'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3 mx-4' style={{ fontSize: '14px' }}>
                      {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['porcPropuestoSolDcto'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['porcPropuestoSolDcto'] !== null &&
                        datosSolicitud.datosSolicitud[0]['porcPropuestoSolDcto'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['porcPropuestoSolDcto']
                        : ''}
                </Form.Text>
                     
                    </Col>  
            </Row>
          
            <Row>
            <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-motivodcto'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['motivoSolDcto'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['motivoSolDcto'] !== null &&
                        datosSolicitud.datosSolicitud[0]['motivoSolDcto'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['motivoSolDcto']
                        : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                       className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-comentario'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['comentarioSolDcto'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['comentarioSolDcto'] !== null &&
                        datosSolicitud.datosSolicitud[0]['comentarioSolDcto'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['comentarioSolDcto']
                        : ''}
                </Form.Text>
                   </Col>
                    
          
            </Row>
            </Container>
            <Row>
              <Col>
              <div >
              <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '17px' }}
                   >
                     {
                       cfg_form26.cfg_form26[
                         'consultasoldescuento-subtitle3-aprobacion'
                       ]
                     }
                   </Form.Label>{' '}

            <hr style={{ color: '#04005D', height: '2px', marginTop:'-15px', marginLeft:'15%'}}></hr>
                </div>
        
              </Col>
            </Row>
            <Container>
            <Row>
              <Col>
              <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['estadoSolicitud'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['estadoSolicitud'] !== null &&
                        datosSolicitud.datosSolicitud[0]['estadoSolicitud'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['estadoSolicitud']
                        : ''}
                </Form.Text></Col>
            <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-porcajustado'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3 mx-4' style={{ fontSize: '14px' }}>
                        {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['porcAjustado'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['porcAjustado'] !== null &&
                        datosSolicitud.datosSolicitud[0]['porcAjustado'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['porcAjustado']
                        : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                       className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-recobajustado'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['montoRecobroAjustado'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['montoRecobroAjustado'] !== null &&
                        datosSolicitud.datosSolicitud[0]['montoRecobroAjustado'] !== ''
                        ? formato_monto(datosSolicitud.datosSolicitud[0]['montoRecobroAjustado'])
                        : ''}
                </Form.Text>
                   </Col>
                    
                   <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form26.cfg_form26[
                            'consultasoldescuento-lbl-comentario'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                        datosSolicitud.datosSolicitud[0]['comentarioRespuesta'] !== undefined &&
                        datosSolicitud.datosSolicitud[0]['comentarioRespuesta'] !== null &&
                        datosSolicitud.datosSolicitud[0]['comentarioRespuesta'] !== ''
                        ? datosSolicitud.datosSolicitud[0]['comentarioRespuesta']
                        : ''}
                </Form.Text>
                     
                    </Col>  
                  
            </Row>
          </Container>
                    </div>
              ) : null}
               <hr style={{ color: '#04005D', height: '2px', marginTop:'15px'}}></hr>
           
           <Row>
                <Col className='d-flex align-items-end justify-content-end m-2'>
                <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}   >
                {cfg_form26 && cfg_form26.cfg_form26["consultasoldescuento-btn-cerrar"]}
                
          </Button>
          </Col>
           </Row>
     
      
   
          </Container>
        </Card>
     
     
    
    </>
  )
}

export default SolicitudDescuento
